import { ReactNode } from 'react';
import { FormattedMessage } from '@alltrails/shared/react-intl';;
import Button from '@alltrails/shared/denali/components/Button';
import OutlinedTextField from '@alltrails/shared/components/OutlinedTextField';
import * as formStyles from '../styles/styles.module.scss';
import * as styles from './styles/styles.module.scss';

type Props = {
  applyHandler(...args: unknown[]): unknown;
  changeHandler?(event: React.ChangeEvent<HTMLInputElement>): void;
  errorMessage?: ReactNode;
  expanded: boolean;
  isSuccess: boolean;
  removeHandler(...args: unknown[]): unknown;
  value: string;
};

function CouponCode({ expanded, applyHandler, changeHandler, removeHandler, isSuccess, errorMessage, value }: Props) {
  if (expanded) {
    const applyButtonContent = !isSuccess ? (
      <Button onClick={applyHandler} testId="apply" text={<FormattedMessage defaultMessage="Apply" />} variant="default" />
    ) : (
      <Button onClick={removeHandler} testId="remove" text={<FormattedMessage defaultMessage="Remove" />} variant="default" />
    );

    return (
      <div className={styles.container}>
        <div className={formStyles.inputGroup}>
          <OutlinedTextField
            changeHandler={changeHandler}
            enterKeyHandler={applyHandler}
            errorMessage={errorMessage}
            isDisabled={isSuccess}
            isSuccess={isSuccess}
            label={<FormattedMessage defaultMessage="Coupon code" />}
            value={value}
          />
          {applyButtonContent}
        </div>
      </div>
    );
  }

  return null;
}

export default CouponCode;
